import React, { useContext, useState } from "react";
import { Form as FinalForm, Field } from "react-final-form";
import { Container, Form, Button } from "semantic-ui-react";
import {
  combineValidators,
  composeValidators,
  isRequired,
  matchesPattern,
  hasLengthLessThan,
} from "revalidate";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import TextInput from "../../../app/common/form/TextInput";
import { IPackageForm } from "../../../app/models/package";
import DateInput from "../../../app/common/form/DateInput";
import { getDateFormatDDMMAAAA } from "../../../app/util/dateOptions";

interface IProps {
  packageForm: IPackageForm;
}

const validate = combineValidators({
  numberOfDocuments: composeValidators(
    isRequired({ message: "El Numero de facturas es obligatorio" }),
    matchesPattern(/^[0-9]*$/)({
      message: "Solo se permiten caracteres numéricos",
    }),
    hasLengthLessThan(6)({
      message: "El Numero de facturas debe tener máximo 5 caracteres",
    })
  )(),
  price: composeValidators(
    isRequired({ message: "El Precio es obligatorio" }),
    matchesPattern(/^[0-9]*$/)({
      message: "Solo se permiten caracteres numéricos",
    }),
    hasLengthLessThan(11)({
      message: "El Precio debe tener máximo 10 caracteres",
    })
  )(),
});

const EditPachageForm: React.FC<IProps> = ({ packageForm }) => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { editPackage } = rootStore.packageStore;
  const { loading } = rootStore.buttonLoadingStore;
  const { client } = rootStore.clienStore;

  const [editPackageForm] = useState<IPackageForm>({
    id: packageForm.id,
    numberOfDocuments: packageForm.numberOfDocuments,
    price: packageForm.price,
    paymentDate: new Date(packageForm.paymentDate),
    expirationDate: new Date(packageForm.expirationDate),
    tenantId: client.id,
  });

  const handleFinalFormSubmit = (values: any) => {
    values.expirationDate = getDateFormatDDMMAAAA(values.expirationDate);
    values.paymentDate = getDateFormatDDMMAAAA(values.paymentDate);
    editPackage(values);
  };

  return (
    <div className="modalContent">
      <FinalForm
        validate={validate}
        initialValues={editPackageForm}
        onSubmit={handleFinalFormSubmit}
        render={({ handleSubmit, values }) => (
          <Form onSubmit={handleSubmit}>
            <Container textAlign="justified">
              <label>No. facturas</label>
              <Field
                name="numberOfDocuments"
                value={editPackageForm.numberOfDocuments}
                defaultValue={editPackageForm.numberOfDocuments}
                component={TextInput}
              />
              <label>Valor pago</label>
              <Field
                name="price"
                value={editPackageForm.price}
                component={TextInput}
              />
              <label>Fecha de pago (dd/mm/yyyy)</label>
              <Field
                name="paymentDate"
                min={new Date()}
                max={
                  values.expirationDate === null
                    ? new Date(2099, 11, 31)
                    : new Date(values.expirationDate)
                }
                value={editPackageForm.paymentDate}
                component={DateInput}
              />
              <label>Fecha fin paquete (dd/mm/yyyy)</label>
              <Field
                name="expirationDate"
                min={
                  values.paymentDate === null
                    ? new Date()
                    : new Date(values.paymentDate)
                }
                value={editPackageForm.expirationDate}
                component={DateInput}
              />
              <br />
              <br />
              <Button
                loading={loading}
                disabled={loading}
                className="ui primary button"
                color="blue"
                type="submit"
                content="Guardar"
              />
            </Container>
          </Form>
        )}
      />
    </div>
  );
};

export default observer(EditPachageForm);
